export interface InboxAddress {
	id: string
	primaryEmail: string
	isPrimary: boolean
}

// Empty for a single-address workspace, where filtering by address is a no-op.
export function sortedInboxAddresses<T extends InboxAddress>(
	addresses: readonly T[],
): T[] {
	if (addresses.length < 2) return []
	return [...addresses].sort((a, b) => {
		if (a.isPrimary !== b.isPrimary) return a.isPrimary ? -1 : 1
		return a.primaryEmail.localeCompare(b.primaryEmail)
	})
}
